import PageLayout from '@/components/PageLayout';
import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import cn from 'classnames';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import { getLayoutProps } from '@/utils/layout/layout';
import { getCategoriesFromFile } from '@/utils/getCategories';
import User from '@/store/user';
import UserOrders from '@/components/UserOrders/UserOrders';
import styles from '@/styles/User.module.css';
export default function UserHistory({ responsiveLogo, image, categoriesFromFile }) {
  const [user, setUser] = useState();

  const router = useRouter();
  useEffect(() => {
    const user$ = User.subscribe(async _user => {
      if (isEmpty(_user)) {
        router.replace('/');
        return;
      }

      setUser(_user);
    });
    return () => user$.unsubscribe();
    //eslint-disable-next-line
  }, []);

  if (!user?._id) return null;
  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>

      <div className={cn(styles.hpWidth)}>
        <UserOrders user={user} image={image} categoriesFromFile={categoriesFromFile} />
      </div>
    </>
  );
}

UserHistory.getLayout = function getLayout(page) {
  return (
    <PageLayout isUserLayout userSelectedMenu={'orders'}>
      {page}
    </PageLayout>
  );
};

export async function getStaticProps({ locale }) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, locale);
  // TODO: Use this on edit order
  const categoriesFromFile = await getCategoriesFromFile(locale);

  const image = layoutProps?.emptyStates?.orders_empty_state?.url
    ? layoutProps?.emptyStates?.orders_empty_state?.url
    : null;
  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    product_details: (await import(`../../../../prebuild-data/i18n/${locale}/product_details.json`)).default,
    user_history: (await import(`../../../../prebuild-data/i18n/${locale}/user_history.json`)).default,
    checkout: (await import(`../../../../prebuild-data/i18n/${locale}/checkout.json`)).default,
    full_page_cart: (await import(`../../../../prebuild-data/i18n/${locale}/full_page_cart.json`)).default,
    category_details: (await import(`../../../../prebuild-data/i18n/${locale}/category_details.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
      image,
      categoriesFromFile,
    },
  };
}
